var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwDreamers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.062 153.448V173.614C324.062 256.6 256.745 324.063 173.614 324.063H153.448C70.4623 324.063 2.99998 256.745 2.99998 173.614V9.38353C2.99998 5.9016 5.90156 3 9.38349 3L173.614 3C256.6 3 324.062 70.3172 324.062 153.448Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.634 169.263C209.887 189.864 189.576 210.32 168.975 258.922C166.508 264.725 158.239 264.725 155.627 258.922C135.026 210.175 114.57 189.864 65.9676 169.263C60.1644 166.796 60.1644 158.527 65.9676 155.915C114.715 135.314 135.026 114.858 155.627 66.2557C158.094 60.4525 166.363 60.4525 168.975 66.2557C189.576 115.003 210.032 135.314 258.634 155.915C264.437 158.382 264.437 166.651 258.634 169.263Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M316.811 3H10.1109C6.18473 3 3.00195 6.18277 3.00195 10.1089V316.809C3.00195 320.735 6.18473 323.917 10.1109 323.917H316.811C320.737 323.917 323.919 320.735 323.919 316.809V10.1089C323.919 6.18277 320.737 3 316.811 3Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwDreamers);
export default __webpack_public_path__ + "static/media/dfw-Dreamers.77a92b4d7a50b358f23cf95182073430.svg";
export { ForwardRef as ReactComponent };